const options = {
    position: "bottom-right",
};
export default options;